<template lang="pug">
.h-vertical-align-container(v-if='modalShow')
  .modal__close(@click='closeModal()')
  .modal__overlay(@click='closeModal()')
  .modal__wrapper.modal__wrapper--buyModal#modalWrapper
    .modal__object#modalForm(v-if='modalForm')
      .modal-content.modal--product.modal__product--form
        .modal__container
          .message__container

            // Success
            .message.success#successMessage(v-if='success')
              p An e-mail has been sent to {{ userInfo.identifier }}
              a.close(@click='hideSuccessMessage()')

            .message.error#errorMessage(v-if='error')
              p {{ errorMessage }}
              a.close(@click='hideErrorMessage()')
          
          // Forget Password component
          forget-pass(v-if='forgotPassword')

          // Registration
          register(
            v-if='registrationForm',
            :product=this.product,
            :coupon=this.coupon)

          // Log in
          login(
            v-if='loginForm',
            :product=this.product,
            :coupon=this.coupon)
</template>

<script>
import { _ } from 'vue-underscore';
import AuthService from 'services/auth.es6.js';
import AccountService from 'services/account.es6.js';
import ProfileService from 'services/profile.es6.js';
import ForgotPasswordService from 'services/forgotpassword.es6.js';
import googleAnalytics from 'services/googleAnalytics.es6.js';
import ProductsService from 'services/products.es6.js';
import UtilitiesService from 'services/utilities.es6.js';

// Form components
import forgetpass from 'components/buyModalForgetPass.vue';
import register from 'components/buyModalRegister.vue';
import login from 'components/buyModalLogin.vue';

import EventBus from '../eventBus.js';

export default {
  name: 'buy-modal',
  data() {
    return {
      userAccount: '',
      // Form/Modal States
      modalShow: false,
      registrationForm: false,
      registrationError: '',
      modalForm: false,
      forgotPassword: false,
      modal: false,
      loginForm: false,
      plan: false,

      // Success/Error States
      success: false,
      error: false,
      errorMessage: '',

      // Form/Modal data
      newUser: {},
      login: {
        username: '',
        password: '',
      },
      userInfo: {
        identifier: '',
      },
      loading: false,
      formData: {},
      product: '',
      coupon: '',
    };
  },
  mounted() {
    const self = this;
    EventBus.$on('showButtonBuyModal', function (product, coupon) {
      self.showButtonBuyModal(product, coupon);
    });
    EventBus.$on('showLogin', function () { self.showLogin(); });
    EventBus.$on('showRegistration', function () { self.showRegistration(); });
    EventBus.$on('showForgetPass', function () { self.showForgetPass(); });
    EventBus.$on('loginUser', function (userAccount) { self.loginUser(userAccount); });
    EventBus.$on('registerUser', function (userInfo) { self.registerUser(userInfo); });
    EventBus.$on('submitForgotPass', function (userInfo) { self.submitForgotPassword_invoke(userInfo); });
    this.userAccount = JSON.parse(localStorage.getItem('account'));
    if (this.$router.currentRoute.query.coupon) {
      self.coupon = this.$router.currentRoute.query.coupon;
    } else {
      this.coupon = localStorage.getItem('coupon');
    }
  },
  methods: {
    showModal() {
      this.modalShow = true;
      this.modalForm = true;
      this.registrationForm = true;
    },
    showLogin() {
      this.registrationForm = false;
      this.forgotPassword = false;
      this.loginForm = true;
    },
    showRegistration() {
      this.registrationForm = true;
      this.loginForm = false;
    },
    showForgetPass() {
      this.loginForm = false;
      this.forgotPassword = true;
    },
    closeModal() {
      this.modalShow = false;
      this.forgotPassword = false;
      this.loginForm = false;
      this.RegistrationForm = false;
    },
    hideSuccessMessage() {
      this.success = false;
    },
    hideErrorMessage() {
      this.errorMessage = '';
      this.error = false;
    },
    loginUser(credentials) {
      const self = this;
      this.loading = true;
      this.formData = credentials;
      this.getAccessToken_invoke(credentials)
        .then(this.getAccount_invoke)
        .then(this.getProfile_invoke)
        .finally(function () {
          self.loading = false;
        });
    },
    registerUser(user) {
      this.formData = user;
      if (!this.validateUserName(user.username)) {
        this.error = true;
        this.errorMessage = 'Username can only contain letters, numbers and \'_\'';
      } else if (this.formData.password.length < 6) {
        this.error = true;
        this.errorMessage = 'Password must be a minimum of 6 characters.';
      } else {
        if (!this.formData.marketing_consent) {
          this.formData.marketing_consent = false;
        }
        this.registerNewUser_invoke(user)
          .then(this.getAccessToken_invoke)
          .then(this.getProfile_invoke);
      }
    },
    // Register New User methods
    registerNewUser_success(data) {
      AuthService.updateUser('account', data.data);
      this.userAccount = data.data;
      ga('send', 'event', 'Register', 'Button Click', 'Register');
      return this.formData;
    },
    registerNewUser_error(registrationError) {
      this.error = true;
      this.errorMessage = registrationError;
      this.loading = false;
      throw new Error(registrationError);
    },
    registerNewUser_invoke(user) {
      return AccountService.register(user)
        .then(this.registerNewUser_success, this.registerNewUser_error);
    },
    // Get Access Token Methods
    getAccessToken_success(data) {
      AuthService.storeAccessToken(data);
      return this.formData.username;
    },
    getAccessToken_error(error) {
      this.error = true;
      this.errorMessage = 'Username, email, or password entered is incorrect.';
      this.loading = false;
      throw new Error(error.error);
    },
    getAccessToken_invoke(login) {
      const userCredentials = _.omit(login, 'email');
      return AuthService.getAccessToken(userCredentials)
        .then(this.getAccessToken_success, this.getAccessToken_error);
    },
    getAccount_success(data) {
      AuthService.updateUser('account', data.data);
      this.userAccount = JSON.parse(localStorage.getItem('account'));
      return data.data.username;
    },
    getAccount_error(error) {
      this.error = true;
      this.errorMessage = 'Something happened during log in. Please contact support at support@flixel.com';
      throw new Error(error);
    },
    getAccount_invoke() {
      return AccountService.get()
        .then(this.getAccount_success, this.getAccount_error);
    },
    getProfile_success(data) {
      AuthService.updateUser('profile', data);
      EventBus.$emit('updateNav');
      if (this.userAccount.subscription.plan === 'free' && this.product === 'weekTrial') {
        this.buyPlan('weekTrial', this.coupon);
        this.resetModal();
      } else if (this.userAccount.subscription.plan === 'free' && this.product === 'monthTrial') {
        this.buyPlan('monthTrial', this.coupon);
        this.resetModal();
      } else if (this.userAccount.subscription.plan === 'free') {
        this.buyPlan(this.product, this.coupon);
        this.resetModal();
      } else if (this.userAccount.subscription.plan !== 'free') {
        this.$router.push('/settings/account/');
      } else {
        this.plan_name = this.userAccount.subscription.plan_display_name;
        this.resetModal();
      }
    },
    getProfile_error(error) {
      this.error = true;
      this.errorMessage = 'profile error : ' + error.detail;
      throw new Error(data);
    },
    getProfile_invoke(data) {
      ProfileService.get(data)
        .then(this.getProfile_success, this.getProfile_error);
    },
    submitForgotPassword_success() {
      this.success = true;
    },
    submitForgotPassword_error(data) {
      this.error = true;
      this.errorMessage = data.response.data.error;
      throw new Error(data);
    },
    submitForgotPassword_readyForm(userInfo) {
      const isEmail = userInfo.identifier.indexOf('@') > 0;
      const key = isEmail ? 'email' : 'username';
      this.userInfo.identifier = userInfo.identifier;
      userInfo[key] = userInfo.identifier;
      return _.pick(userInfo, key);
    },
    submitForgotPassword_invoke(userInfo) {
      const form = this.submitForgotPassword_readyForm(userInfo);
      ForgotPasswordService.post(form)
        .then(this.submitForgotPassword_success, this.submitForgotPassword_error);
    },

    /*
    * Validation
    */

    validateUserName(username) {
      const usernameRegex = UtilitiesService.regValidUsername();
      return usernameRegex.test(username);
    },
    buyPlan(productKey, coupon) {
      this.closeModal();
      ProductsService.productForKey(productKey).buy.action(coupon);
    },
    showButtonBuyModal(product, coupon) {
      if (!coupon) {
        this.coupon = localStorage.getItem('coupon');
      } else {
        this.coupon = coupon;
      }

      if (product.includes('trial')) {
        ga('send', 'event', 'Start Trial', 'Button Click', product, '7');
      } else {
        ga('send', 'event', 'Buy Now', 'Button Click', product);
      }

      if (!this.userAccount) {
        ga('send', 'event', 'Registration Form Shown', 'Registration Form', 'Modal shown');
        this.product = product;
        this.showModal();
      } else {
        this.buyPlan(product, this.coupon);
      }
    },
    resetModal() {
      this.error = false;
      this.freePlan = true;
      this.plan = true;
      this.form = false;
    },
  },
  components: {
    'forget-pass': forgetpass,
    'register': register,
    'login': login,
  },
};
</script>


// WEBPACK FOOTER //
// src/components/buyModal.vue